import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

interface InputProps {
	placeholder?: string;
	className?: string;
	variant?: "primary" | "secondary";
	isDisabled?: boolean;
	label?: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
}

const CustomPasswordInput: React.FC<InputProps> = ({
	onChange,
	placeholder,
	className = "",
	value,
	error,
	isDisabled = false,
}) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	const baseStyles =
		"px-4 py-3 rounded-md font-semibold transition-all duration-200 flex items-center justify-between outline-none focus:border-blue-500 w-full";

	return (
		<div className="flex flex-col gap-2">
			<div className={`relative ${className}`}>
				<input
					className={`${baseStyles}`}
					placeholder={placeholder}
					value={value}
					type={showPassword ? "text" : "password"}
					onChange={(e) => onChange(e.target.value)}
					disabled={isDisabled}
				/>
				<button
					type="button"
					onClick={togglePasswordVisibility}
					className="absolute right-2 top-3 focus:outline-none"
					aria-label={showPassword ? "Hide password" : "Show password"}
				>
					<FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
				</button>
			</div>
			{error && <span className="text-red-500">{error}</span>}
		</div>
	);
};

export default CustomPasswordInput;
